import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import Seo from "../components/Seo";
import EnquiryForm from "../components/EnquiryForm";
import { CONTACT } from "../siteConfig";
import { Reveal, SectionHead } from "../components/Reveal";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-[72px]">
      <Seo
        title="Contact Mangalam Group — Dhanbad, Jharkhand"
        description="Reach Mangalam Group for BKT tyres, OTR and CVR tyre solutions and tyre management. Head office: Dhanbad, Jharkhand. Phone +91 3264004712."
        path="/contact"
      />

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHead
            eyebrow="Contact"
            title="Talk to Our Team"
            copy="Tell us about your application — or reach us directly by phone, email or WhatsApp."
          />

          <div className="mt-14 grid gap-10 lg:grid-cols-[1fr_1.3fr]">
            <Reveal>
              <div className="space-y-px border border-white/10 bg-white/10">
                <div className="bg-obsidian-2 p-6">
                  <p className="flex items-center gap-3 font-mono text-[10px] tracking-[0.25em] uppercase text-ember">
                    <MapPin className="h-4 w-4" /> Head Office
                  </p>
                  <p data-testid="contact-address" className="mt-3 font-condensed text-2xl font-bold uppercase tracking-wide text-white">
                    {CONTACT.address}
                  </p>
                  <p className="mt-2 text-sm text-slate-400">Branches and site teams across the region — details available on enquiry.</p>
                </div>
                <a href={CONTACT.phoneHref} data-testid="contact-phone" className="block bg-obsidian-2 p-6 transition-colors hover:bg-obsidian-3">
                  <p className="flex items-center gap-3 font-mono text-[10px] tracking-[0.25em] uppercase text-ember">
                    <Phone className="h-4 w-4" /> Phone
                  </p>
                  <p className="mt-3 font-condensed text-2xl font-bold tracking-wide text-white">{CONTACT.phone}</p>
                </a>
                <a href={`mailto:${CONTACT.email}`} data-testid="contact-email" className="block bg-obsidian-2 p-6 transition-colors hover:bg-obsidian-3">
                  <p className="flex items-center gap-3 font-mono text-[10px] tracking-[0.25em] uppercase text-ember">
                    <Mail className="h-4 w-4" /> Email
                  </p>
                  <p className="mt-3 break-all font-condensed text-xl font-bold tracking-wide text-white">{CONTACT.email}</p>
                </a>
                <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="block bg-obsidian-2 p-6 transition-colors hover:bg-obsidian-3">
                  <p className="flex items-center gap-3 font-mono text-[10px] tracking-[0.25em] uppercase text-ember">
                    <MessageCircle className="h-4 w-4" /> WhatsApp
                  </p>
                  <p className="mt-3 font-condensed text-2xl font-bold uppercase tracking-wide text-white">Message us directly</p>
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="border border-white/10 bg-obsidian-2 p-6 lg:p-8">
                <h2 className="font-condensed text-2xl font-bold uppercase tracking-wide text-white">
                  Looking for the Right Tyre Solution?
                </h2>
                <div className="mt-6">
                  <EnquiryForm />
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal className="mt-10">
            <div data-testid="contact-map" className="overflow-hidden border border-white/10">
              <iframe
                title="Mangalam Group — Dhanbad, Jharkhand"
                src="https://www.google.com/maps?q=Dhanbad,+Jharkhand,+India&output=embed"
                className="h-[380px] w-full grayscale-[35%] contrast-[1.05]"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
